<script lang="ts" setup>
import { computed, ref } from '#imports';
import { useService } from '@kaokei/use-vue-service';
import cpp1jpeg from '~/assets/image/qrcode/newuser/cpp_21.jpg';
import cpp2jpeg from '~/assets/image/qrcode/newuser/cpp_22.jpg';
import cpp3jpeg from '~/assets/image/qrcode/newuser/cpp_23.jpg';
import cpp4jpeg from '~/assets/image/qrcode/newuser/cpp_24.jpg';
import perseveringFaceGif from '~/assets/image/qrcode/newuser/persevering-face.gif';
import perseveringFacePng from '~/assets/image/qrcode/newuser/persevering-face.png';
import teacherPng from '~/assets/image/qrcode/newuser/teacher@2x.png';
import { ProfileService } from '~/services/profile.service';

const service = useService(ProfileService);
const qrcodeList = [cpp1jpeg, cpp2jpeg, cpp3jpeg, cpp4jpeg];

const qrcode = computed(() => {
  return qrcodeList[service.programLevel - 1] || qrcodeList[0];
});

const eventData = computed(() => ({
  sub_type: `${service.programLevel}`,
}));

function handleClose() {
  service.newUserAddTeacherVisible = false;
}

const hover = ref(false);
function handleMouseenter() {
  hover.value = true;
}
function handleMouseleave() {
  hover.value = false;
}
</script>

<template>
  <a-modal
    v-model:open="service.newUserAddTeacherVisible"
    :width="400"
    :footer="null"
    :closable="false"
    :mask-closable="false"
    :destroy-on-close="true"
    :centered="true"
    wrap-class-name="plain-modal"
  >
    <div v-track:oj_show_newuser_drainage="eventData">
      <div class="relative -bottom-6 z-10 w-[400px] px-1">
        <img :src="teacherPng" alt="teacher" />
      </div>
      <div class="bg-add-teacher-modal relative z-20 h-[386px] w-[400px]">
        <div class="mx-auto h-[150px] w-[150px] pt-[92px]">
          <img :src="qrcode" alt="qrcode" />
        </div>

        <div class="absolute bottom-8 w-full px-[50px]">
          <a-button
            block
            size="large"
            class="!flex h-10 w-40 !border-colorFill flex-center"
            @mouseenter="handleMouseenter"
            @mouseleave="handleMouseleave"
            @click="handleClose"
          >
            <img
              v-show="hover"
              :src="perseveringFaceGif"
              alt="cry"
              class="h-[18px] w-[18px]"
            />
            <img
              v-show="!hover"
              :src="perseveringFacePng"
              alt="cry"
              class="h-[18px] w-[18px]"
            />
            <div
              class="ml-1 text-sm font-bold leading-[18px] text-colorTextSecondary"
            >
              放弃福利
            </div>
          </a-button>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<style scoped>
.bg-add-teacher-modal {
  background: url(~/assets/image/qrcode/newuser/box@2x.png) 0 0 no-repeat;
  background-size: 100% 100%;
}
</style>
